import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { getSupermarketCategoryApi, RemovemarketCategoryAPI } from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import EditFirstLevelCategory from "../../Modal/Information/EditFirstLevelCategory/EditFirstLevelCategory";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import CategoryLevelOneTable from "../../Tables/Category/CategoryLevelOneTable/CategoryLevelOneTable";
import Style from "./LevelOneCategoryListContainer.module.scss";

const LevelOneCategoryListContainer = () => {
  const [category, setCategory] = useState([]);
  const [rawInfo, setRawInfo] = useState([]);
  const [modalEditShow, setModalEditShow] = useState(false);

  useEffect(() => {
    getMarketCategory();
  }, []);

  const getMarketCategory = async () => {
    getSupermarketCategoryApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setCategory(res.category);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };

  const btnHandler = (id, info) => {
    setRawInfo(info);
    if (id === 1) {
      let id={
        id:info.key
      }
      RemovemarketCategoryAPI(id,res=>{
        if(res.status===1){
          succToast(res.message)
        }else{
          errorToast(res.message)
        }
      })
      getMarketCategory()
    } else if (id === 2) {
      setModalEditShow(true)
    }
  };

  const closeModals=()=>{
    setModalEditShow(false)
  }
  let categoryFirst = [];
  category.forEach((val) => {
    if (val.parent === "2") {
      categoryFirst.push(val);
    }
  });

  const data =
    categoryFirst &&
    categoryFirst.map((item) => {
      return {
        key: item.id,
        namePersian: item.category,
        nameEnglish: item.category_english,
      };
    });
  
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"لیست دسته بندی سطح اول فروشگاه"} />
      <Modal show={modalEditShow} onHide={closeModals}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>ویرایش دسته بندی سطح اول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditFirstLevelCategory info={rawInfo} setModalEditShow={setModalEditShow} getMarketCategory={getMarketCategory}/>
        </Modal.Body>
      </Modal>
      <CategoryLevelOneTable data={data} btnHandler={btnHandler} />
    </div>
  );
};

export default LevelOneCategoryListContainer;
